module.exports = __webpack_public_path__ + "static/img/静止.b5cd022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/商务车（含面包）/静止.png
// module id = CaVX
// module chunks = 76